import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const DinningTableIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "DinningTableIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M15.1808 18.7057L14.1202 17.9986V12.9899H19.1492C19.7047 12.9899 20.155 12.5396 20.155 11.9841V10.9783C20.155 10.4228 19.7047 9.97244 19.1492 9.97244H17.6149C17.3727 7.59437 15.4924 5.71406 13.1143 5.47193V4.94338H13.6173C13.895 4.94338 14.1202 4.71822 14.1202 4.44047C14.1202 4.16272 13.895 3.93756 13.6173 3.93756H11.6056C11.3279 3.93756 11.1027 4.16272 11.1027 4.44047C11.1027 4.71822 11.3279 4.94338 11.6056 4.94338H12.1085V5.47193C9.73046 5.71407 7.85015 7.59438 7.60802 9.97244H5.57075C5.01525 9.97244 4.56494 10.4228 4.56494 10.9783V11.9841C4.56494 12.5396 5.01526 12.9899 5.57075 12.9899H11.1027V17.9986L10.0421 18.7057C9.76221 18.8922 9.59406 19.2062 9.594 19.5425V19.7764C9.594 20.3319 10.0443 20.7822 10.5998 20.7822H14.6231C15.1786 20.7822 15.6289 20.3319 15.6289 19.7764V19.5425C15.6288 19.2062 15.4607 18.8922 15.1808 18.7057ZM12.6114 6.45209C14.6371 6.45546 16.345 7.96289 16.6 9.97244H8.62288C8.87786 7.96289 10.5858 6.45546 12.6114 6.45209ZM5.57074 11.9841V10.9783H19.1492V11.9841H5.57074ZM14.6231 19.7764H10.5998V19.5425L11.6604 18.8354C11.9403 18.649 12.1085 18.3349 12.1085 17.9986V12.9899H13.1143V17.9986C13.1144 18.3349 13.2826 18.649 13.5624 18.8354L14.6231 19.5425V19.7764Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default DinningTableIcon;
